import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json';
// import prism from 'react-syntax-highlighter/dist/esm/styles/prism/json';


import { dark, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

SyntaxHighlighter.registerLanguage('json', json);



const CodeView = ({ language, code }) => {

    return (
        <SyntaxHighlighter language={language} style={oneLight}
            customStyle={{
                fontSize: ".9em",
                maxWidth: "100%",
            }}
            wrapLongLines={true}
        >
            {code}
        </SyntaxHighlighter>
    );
};

export default CodeView;